import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  name: 'Marcos R.',
  location: 'Buenos Aires',
  role: 'Instructor de Karate — 12 años',
  avatar: '🥋',
  quote: 'Llevaba años improvisando cada clase. Me sentaba antes a pensar qué enseñar y perdía una hora. Con la Agenda de 52 Semanas planifiqué todo el año en un fin de semana. Mis alumnos lo notaron de inmediato.',
  time: '14:32',
  reply: '💪 ¡Enorme, Marcos! Planificar es la base de todo. Tus alumnos tienen suerte de tenerte.'
}, {
  initials: 'DP',
  name: 'Diego P.',
  location: 'Córdoba',
  role: 'Dueño de Dojo de Judo',
  avatar: '🏋️',
  quote: 'Tenía 35 alumnos hace dos años y seguía teniendo 35. No crecía. Con el Tomo 3 de Marketing Guerrero en 60 días sin gastar un peso en publicidad llegué a 52 alumnos. El sistema funciona de verdad.',
  time: '09:15',
  reply: '🔥 De 35 a 52 sin publicidad… eso es puro sistema. ¡Felicitaciones, Diego!'
}, {
  initials: 'FS',
  name: 'Federico S.',
  location: 'Rosario',
  role: 'Instructor de Taekwondo',
  avatar: '🦵',
  quote: 'Se me iban alumnos y no entendía por qué. Implementé el sistema de retención del Tomo 2 y el Script Anti-Deserción del Bono 3. En menos de un mes frenó la hemorragia. Lo que no pude hacer en años lo resolví en semanas.',
  time: '18:47',
  reply: '🙌 Frenar la deserción es el primer paso, Fede. Ahora a crecer sin perder.'
}, {
  initials: 'LM',
  name: 'Lucas M.',
  location: 'Mendoza',
  role: 'Instructor de Kickboxing',
  avatar: '🥊',
  quote: 'El Tomo 5 de Psicología del Cierre cambió todo. Antes me daba vergüenza cobrar lo que valía. Ahora tengo un sistema para inscribir alumnos sin presionar y convertí el 70% de las consultas del mes pasado.',
  time: '11:03',
  reply: '👏 70% de conversión es nivel élite, Lucas. Cobrar lo justo no es presionar, es profesionalismo.'
}, {
  initials: 'AG',
  name: 'Alejandro G.',
  location: 'Tucumán',
  role: 'Instructor de Kung Fu',
  avatar: '🐉',
  quote: 'La Planilla de Control de Cobros del Bono 4 me hizo dar cuenta que estaba perdiendo $80.000 pesos por mes en cuotas sin cobrar. En el primer mes que la implementé recuperé $60.000. Solo con eso se pagó el megapack diez veces.',
  time: '20:21',
  reply: '💰 $60.000 recuperados en un mes… ¡esa plata ya estaba ahí, solo faltaba el sistema! Grande, Ale.'
}, {
  initials: 'NB',
  name: 'Nicolás B.',
  location: 'Santa Fe',
  role: 'Instructor de BJJ',
  avatar: '🤼',
  quote: 'Organicé mi primer seminario con la Guía del Bono 6. 22 asistentes a $5.000 cada uno. $110.000 pesos en un sábado. Antes nunca me animé porque no sabía cómo hacerlo. El sistema lo explica todo paso a paso.',
  time: '16:58',
  reply: '🚀 ¡$110.000 en un sábado! Eso es lo que pasa cuando te animás con el paso a paso. Crack, Nico.'
}, {
  initials: 'PL',
  name: 'Pablo L.',
  location: 'Neuquén',
  role: 'Dueño de Academia de MMA',
  avatar: '👊',
  quote: 'Lo que más me cambió fue el Tomo 6 de Liderazgo. Formé dos monitores en 3 meses y ahora me puedo tomar un fin de semana sin que el dojo se detenga. Eso para mí no tiene precio.',
  time: '13:44',
  reply: '🏆 Delegar sin que se caiga todo… eso es ser dueño de verdad. Bien ahí, Pablo.'
}];
function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full shrink-0" style={{
    backgroundColor: '#111b21'
  }} data-id="element-279">
      {/* WhatsApp Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-280">
        <div className="relative" data-id="element-281">
          <div className="w-10 h-10 rounded-full flex items-center justify-center text-xl" style={{
          backgroundColor: '#2a3942'
        }} data-id="element-282">
            {t.avatar}
          </div>
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#25d366',
          borderColor: '#1f2c34'
        }} data-id="element-283"></div>
        </div>
        <div className="flex-1 min-w-0" data-id="element-284">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-285">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-286">
            {t.role} · {t.location}
          </p>
        </div>
        <div className="flex items-center gap-3" style={{
        color: '#aebac1'
      }} data-id="element-287">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-288">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-289" />
          </svg>
        </div>
      </div>

      {/* Chat wallpaper area */}
      <div className="px-3 py-4 min-h-[140px] flex flex-col justify-end gap-1" style={{
      backgroundColor: '#0b141a',
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='p' width='40' height='40' patternUnits='userSpaceOnUse'%3E%3Ccircle cx='20' cy='20' r='1' fill='%23ffffff08'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='200' height='200' fill='url(%23p)'/%3E%3C/svg%3E\")"
    }} data-id="element-290">
        {/* Message bubble */}
        <div className="max-w-[92%] self-start relative" data-id="element-291">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-292"></div>
          <div className="rounded-lg rounded-tl-none px-3 py-2 relative" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-293">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-294">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-295">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-296">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-297">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-298" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-299" />
              </svg>
            </div>
          </div>
        </div>

        {/* Our reply bubble */}
        <div className="max-w-[75%] self-end relative mt-1" data-id="element-300">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #005c4b',
          borderRight: '8px solid transparent'
        }} data-id="element-301"></div>
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          backgroundColor: '#005c4b'
        }} data-id="element-302">
            <p className="m-0 text-sm" style={{
            color: '#e9edef'
          }} data-id="element-303">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-304">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-305">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-306">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-307" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-308" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp input bar */}
      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-309">
        <div className="flex items-center gap-2" style={{
        color: '#8696a0'
      }} data-id="element-310">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-311">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-312" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-313">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} data-id="element-314">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-315">
            <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-316" />
          </svg>
        </div>
      </div>
    </div>;
}
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = testimonials.length;
  const goTo = useCallback((index: number, dir: number) => {
    setDirection(dir);
    setCurrent(index);
  }, []);
  const next = useCallback(() => {
    goTo((current + 1) % total, 1);
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, -1);
  }, [current, total, goTo]);
  // Auto-advance every 10 seconds — never pauses
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      next();
    }, 10000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  // Swipe support
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0
    })
  };
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: 'rgb(12, 22, 30)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-317">
      <div className="mx-auto max-w-2xl" data-id="element-318">
        {/* TÍTULO */}
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-2" data-id="element-319">
          Lo que dicen los instructores que ya lo implementaron:
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-320">
          +800 dojos de todo el país ya tienen un sistema que funciona.
        </p>

        {/* CAROUSEL */}
        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-321">
          {/* Arrows */}
          <button onClick={() => prev()} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#25d366',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-322">
            <ChevronLeftIcon size={20} data-id="element-323" />
          </button>
          <button onClick={() => next()} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#25d366',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-324">
            <ChevronRightIcon size={20} data-id="element-325" />
          </button>

          {/* Card container */}
          <div className="overflow-hidden rounded-xl" data-id="element-326">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-327">
              <motion.div key={current} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-328">
                <WhatsAppChat t={testimonials[current]} data-id="element-329" />
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Progress bar */}
          <div className="mt-4 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-330">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            backgroundColor: '#25d366',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 10s linear forwards'
          }} data-id="element-331" />
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-332">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 1 : -1)} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            backgroundColor: i === current ? '#25d366' : '#2a3942'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-333" />)}
          </div>

          {/* Counter */}
          <p className="text-center mt-3 m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-334">
            {current + 1} / {total}
          </p>
        </div>
      </div>
    </section>;
}